import PropTypes from "prop-types";
import * as React from "react";
import SoftBox from "../../../components/SoftBox";
import {useEffect, useState} from "react";
import Servidores from "../../../Repository/Banca/Servidores";
import {v4} from "uuid";
import Box from "@mui/material/Box";
import AlphaTable from "../../cuentas/components/AlphaTable";
import Grid from "@mui/material/Grid";
import {useAlphaAlertModal} from "../../../customHooks/useAlphaAlertModal";
import {useDispatch} from "react-redux";
import {closeGeneralLoader, openGeneralLoader} from "../../../store/slice/alertSlice";
const Horario = ({ server_uuid = '' }) => {
    const dispatch = useDispatch();
    const { setOpenAlert,alphaAlert,setMessageAlert,openAlert } = useAlphaAlertModal();
    const [programacion, setProgramacion] = useState([]);
    const srvInstance = new Servidores();
    useEffect( () => {
        async function consultarHorario(server_uuid){
            const { status, response = [] } = await srvInstance.consultarHorario(server_uuid);
            if(status === "ok"){
                setProgramacion(response)
                console.log(response);
            };
        }
        consultarHorario(server_uuid);
    }, []);

    const headers = [
        { name:"Día", width:"4%" },
        { name:"Habilitado", width:"1%" },
        { name:"Encendido", width:"5%" },
        { name:"Apagado", width:"5%" },
    ];

    const handleChange = (index, field, value) => {
        setProgramacion(prev => {
            const copia = [...prev];
            copia[index] = { ...copia[index], [field]: value };
            return copia;
        });
    };

    async function onClickActualizarHorario()
    {
        dispatch( openGeneralLoader() )
        const {  response = [] } = await srvInstance.almacenarHorario(server_uuid,{ horario: programacion } );
        setMessageAlert(response);
        setOpenAlert(true);
        dispatch(closeGeneralLoader());
    }

    const rows = programacion.map((element, index) => (
            <tr key={`${element.Servidor_uuid}-${element.dia}`}>
                <td><label className={"ILabelLink"}>{element.diaNombre}</label></td>
                <td className={"IColumnCenter"}>
                    <input type={"checkbox"} id={"encendido_programado"} name={"encendido_programado"}
                           checked={element.deshabilitado}
                           onChange={(e) => handleChange(index, "deshabilitado", e.target.checked)}
                    />
                </td>
                <td>
                    <input type={"time"} className={"ITextbox"} name={"encendido"}
                           value={element.encendido}
                           onChange={(e) => handleChange(index, "encendido", e.target.value)}
                    />
                </td>
                <td>
                    <input type={"time"} className={"ITextbox"} name={"apagado"}
                           value={element.apagado}
                           onChange={(e) => handleChange(index, "apagado", e.target.value)}
                    />
                </td>
            </tr>
        )
    );

    return (
        <SoftBox bgColor={"white"} mt={2}>
            <div className="accordion">
                <div className="accordion-header">
                <i className={" icons-alpha"}></i> <label
                    className={"filtro-text"}>{"Horario del Servidor"}</label>

                </div>
                <SoftBox sx={{border: "5px solid #E6E6E6", paddingLeft: 1, paddingRight: 1, marginTop: 1}}>
                    <AlphaTable records={ rows } headers={ headers } />
                    <Grid container justifyContent={"flex-end"}>
                        <Grid item xs={12} md={3} xl={2} mt={2}>
                            <button className={"btn-alpha-success-2"} type={"submit"} onClick={onClickActualizarHorario}>
                                <i className="fa-regular fa-floppy-disk"></i> Actualizar horario
                            </button>
                        </Grid>
                    </Grid>
                </SoftBox>
            </div>
            {
                openAlert && alphaAlert
            }
        </SoftBox>
    );
}
Horario.propTypes = {
    server_uuid: PropTypes.string,
};
export default Horario;